export default __webpack_public_path__ + "static/media/CS-RZ25WKRW 1.6d1c2ff9.jpg";